import { render, staticRenderFns } from "./mySecond.vue?vue&type=template&id=04d77992&scoped=true"
import script from "./mySecond.vue?vue&type=script&lang=js"
export * from "./mySecond.vue?vue&type=script&lang=js"
import style0 from "./mySecond.vue?vue&type=style&index=0&id=04d77992&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d77992",
  null
  
)

export default component.exports